import React, { useEffect, useState } from "react";
import Header from "../Core/Header";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { motion } from "motion/react";
import { baseURL, buses } from "../../service/api_endpoints";
import Footer from "../Core/Footer";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { getBusDetails } from "../../service/operations/api_methods";
import { setBus } from "../../redux/slices/bookingSlice";
import { useMediaQuery } from "usehooks-ts";

const BusDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showHeader, setShowHeader] = useState(true);

  const mobile = useMediaQuery("(max-width: 767px)");
  const plan = useSelector((state) => state?.booking?.plan);
  const bus = useSelector((state) => state?.booking?.bus);
  const [bookingType, setBookingType] = useState(
    bus?.defaultRoute?.bookingStatus?.bookingType || "regular",
  );
  const token = Cookies.get("roam-token");
  const [mainModal, setMainModal] = useState(false);
  const [roundModal, setRoundModal] = useState(false);
  const [modalMode, setModalMode] = useState("pickup");
  const [dyVdo, setDyVdo] = useState("");
  const [selectedBus, setSelectedBus] = useState(bus);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [selectedBackSeats, setSelectedBackSeats] = useState([]);
  const [boardingPoint, setBoardingPoint] = useState(null);
  const [currentPickup, setCurrentPickup] = useState(null);
  const [boardingPointName, setBoardingPointName] = useState(null);
  const [droppingPoint, setDroppingPoint] = useState(null);
  const [droppingPointName, setDroppingPointName] = useState(null);
  const [instantPassengers, setInstantPassengers] = useState(0);
  const [calcFare, setCalcFare] = useState(0);
  const [calcDistance, setCalcDistance] = useState("");
  const [direction, setDirection] = useState("UP");
  const [upDetails, setUpDetails] = useState(null);
  const route1Seats = bus?.routes[0]?.seats || [];
  const route2Seats = bus?.routes[1]?.seats || [];

  const [boarding, setBoarding] = useState(plan?.boarding || "");
  const [dropping, setDropping] = useState(plan?.dropping || "");
  const [time, setTime] = useState(plan?.time || "");
  const [bookingPolicy, setBookingPolicy] = useState(null);

  const [seats, setSeats] = useState([]);
  const [busType, setBusType] = useState(bus?.seatConfiguration?.busType || "");
  const [leftSeats, rightSeats] = busType.split("*").map(Number);
  const totalColumns = leftSeats + rightSeats;
  const [unAvailableSeats, setUnAvailableSeats] = useState([]);
  const [tripType, setTripType] = useState("oneWay");

  useEffect(()=>{
     if (!token|| !plan||!bus) {
      navigate("/login");
    }
  },[])

  useEffect(() => {
    // Scroll to top smoothly when page loads
    window.scrollTo({ top: 0, behavior: "smooth" });

    function abc() {
      const mergedSeats = route1Seats.map((seat1) => {
        const seat2 = route2Seats.find(
          (s) => s.seatNumber === seat1.seatNumber,
        );

        return {
          ...seat1,
          isAvailable: seat1.isAvailable && (seat2?.isAvailable ?? true),
        };
      });
      setSeats(mergedSeats);
    }
    abc();

    const handelBusDetails = async (id = bus?.id) => {
      // console.log(bus);

      try {
        let params = {
          from: boarding,
          to: dropping,
          date: time,
          timeSlot: bus?.defaultRoute.timeSlot,
        };
        const response = await getBusDetails({ id: id, token: token, params });
        console.log("bus detail", response);
        if (!response.data?.bus) {
          toast.error("Failed to get Bus details");
          return;
        }
        if (response.status === 200) {
          console.log("policy");

          console.log(response.data.bookingPolicy);
          setBookingPolicy(response.data?.bookingPolicy);

          // dispatch(setBus(updatedBus))
        }
      } catch (error) {
        console.log(error);
        toast.error("Failed to get Bus details");
        return;
      }
    };

    handelBusDetails();
  }, []);

  const [busSelectLoading, setBusSelectLoading] = useState(null);

  const parseBusType = (type) => {
    const [left, right] = type.split("*").map(Number);
    return { leftSeats: left, rightSeats: right };
  };

  const groupByRow = (seats) => {
    const map = {};

    seats.forEach((seat) => {
      if (!map[seat.row]) map[seat.row] = [];
      map[seat.row].push(seat);
    });

    return Object.keys(map)
      .sort((a, b) => Number(a) - Number(b))
      .map((row) => ({
        row: Number(row),
        seats: map[row].sort((a, b) => a.column - b.column),
      }));
  };

  const handleFareCalculation = (name, city, id) => {
    let drop = currentPickup?.toCells?.find((i) => i?.toName === id);
    if (!drop) {
      drop = currentPickup?.toCells?.find((i) => i?.toName === name);
    }
    if (!drop) {
      drop = currentPickup?.toCells?.find((i) => i?.toName === city);
    }
    console.log(drop, currentPickup, id);

    setCalcFare(drop && drop?.price );
    setCalcDistance(drop && drop?.distanceKm );
  };

  const getColumnCountForRow = (rowSeats) => {
    return Math.max(...rowSeats.map((s) => s.column));
  };

  const Seat = ({ seat }) => {
    const disabled = !seat.isAvailable || !seat.isBookable;

    return (
      <div
        onClick={() => {
          if (!disabled){ console.log(seat.seatNumber);
            handleSeatSelection(seat.seatNumber);
            
          }
          else{
            console.log(seat.seatNumber);
             return
          }
         
        }}
        style={{
          width: "36px",
          height: "36px",
          background: selectedSeats.includes(seat.seatNumber)
            ? "#093c8a"
            : disabled
              ? "#9ca3af"
              : "#16a34a",
          borderRadius: "6px",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "11px",
          fontWeight: "600",
          cursor: disabled ? "not-allowed" : "pointer",

          userSelect: "none",
        }}
      >
        {seat.seatNumber}
      </div>
    );
  };

  const SeatRow = ({ rowSeats, leftSeats }) => {
    const maxColumn = Math.max(...rowSeats.map((s) => s.column));

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px",
        }}
      >
        {Array.from({ length: maxColumn }).map((_, index) => {
          const column = index + 1;
          const seat = rowSeats.find((s) => s.column === column);

          return (
            <React.Fragment key={column}>
              {/* INSERT AISLE */}
              {column === leftSeats + 1 && maxColumn > leftSeats && (
                <div style={{ width: "24px" }} />
              )}

              {seat ? <Seat seat={seat} /> : <div style={{ width: "36px" }} />}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const BusSeatLayout = ({ seats, busType }) => {
    const rows = groupByRow(seats);
    const { leftSeats } = parseBusType(busType);

    return (
      <div
        style={{
          padding: "16px",
          background: "#f9fafb",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          width: "fit-content",
        }}
      >
        <div
          style={{
            textAlign: "right",
            marginBottom: "12px",
            fontWeight: "600",
          }}
        >
          <img src="/Assets/wheel.png" />
        </div>

        {rows.map(({ row, seats }) => (
          <SeatRow key={row} rowSeats={seats} leftSeats={leftSeats} />
        ))}
      </div>
    );
  };

  const handleSeatSelection = (item) => {
    if (
      unAvailableSeats.find((i) => Number(i.seatNumber.substring(1)) === item)
    ) {
      toast.error("not available");
      return;
    }
    setSelectedSeats((prev) => {
      const newList = prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item];
      console.log("updated list:", newList);
      return newList;
    });
  };

  const truncateToWords = (text, limit = 20) => {
    if (typeof text !== "string") return "";

    const words = text.trim().split(/\s+/);

    if (words.length <= limit) {
      return words.join(" ");
    }

    return words.slice(0, limit).join(" ") + " ...";
  };

  const handleUpConform = async () => {
    if (bookingType === "regular") {
      if (!boardingPoint || !droppingPoint) {
        toast.info("Please select boarding and dropping points");
        return;
      }
      if (selectedSeats.length === 0) {
        toast.info("Please select at least one seat to proceed");
        return;
      }
    }

    let data = {
      routeId: selectedBus.routes[0].routeId,
      boardingPoint,
      boardingPointName,
      droppingPoint,
      droppingPointName,
      seatNumbers:
        bookingType === "regular"
          ? selectedSeats
          : Array.from({ length: instantPassengers }, (_, i) => i + 1),
      backSeatNumbers: JSON.stringify(selectedBackSeats),
      selectedBus: selectedBus,
      trip: tripType,
      booking: bookingType,
      fare: calcFare,
      date: bus?.searchCriteria?.date,
      timeSlotSequence: selectedBus.routes[0].timeSlot,
      departureTime:
        selectedBus.routes[0].journeyTiming.departureTime || "00:00:00",
      arrivalTime:
        selectedBus.routes[0].journeyTiming.arrivalTime || "00:00:00",
    };
    console.log("booking data", data);
    setUpDetails(data);
    setDirection("DOWN");
    setSelectedSeats([]);
    setBoardingPoint("");
    setBoardingPointName("");
    setDroppingPoint("");
    setDroppingPointName("");
    setCurrentPickup(null);
    setCalcFare(0);
    setCalcDistance("");
    toast.info("Now select seats for return direction");
  };

  const handleRoundConformBooking = async () => {

    if(selectedBus?.routes.length<2){
        return
    }
    if (bookingType === "regular") {
      if (!boardingPoint || !droppingPoint) {
        toast.info("Please select boarding and dropping points");
        return;
      }
      if (selectedSeats.length === 0) {
        toast.info("Please select at least one seat to proceed");
        return;
      }
    }

    let data = {
      routeId: selectedBus.routes[1]?.routeId,
      boardingPoint,
      boardingPointName,
      droppingPoint,
      droppingPointName,
      seatNumbers:
        bookingType === "regular"
          ? selectedSeats
          : Array.from({ length: instantPassengers }, (_, i) => i + 1),
      backSeatNumbers: JSON.stringify(selectedBackSeats),
      selectedBus: selectedBus,
      trip: tripType,
      booking: bookingType,
      fare: calcFare,
      date: bus?.searchCriteria?.date,
      timeSlotSequence: selectedBus.routes[1]?.timeSlot,
      departureTime:
        selectedBus.routes[1]?.journeyTiming.departureTime || "00:00:00",
      arrivalTime:
        selectedBus.routes[1]?.journeyTiming.arrivalTime || "00:00:00",
    };
    let body = {
      up: upDetails,
      down: data,
    };
    console.log("booking data", body);
    await localStorage.setItem("roam-booking", JSON.stringify(body));
    navigate("/payment");
  };

  const handleConfirmBooking = async () => {
    if (bookingType === "regular") {
      if (!boardingPoint || !droppingPoint) {
        toast.info("Please select boarding and dropping points");
        return;
      }
      if (selectedSeats.length === 0) {
        toast.info("Please select at least one seat to proceed");
        return;
      }
    }

    let data = {
      routeId: selectedBus.routes[0].routeId,
      boardingPoint,
      boardingPointName,
      droppingPoint,
      droppingPointName,
      seatNumbers:
        bookingType === "regular"
          ? selectedSeats
          : Array.from({ length: instantPassengers }, (_, i) => i + 1),
      backSeatNumbers: JSON.stringify(selectedBackSeats),
      selectedBus: selectedBus,
      trip: tripType,
      booking: bookingType,
      fare: calcFare,
      date: bus?.searchCriteria?.date,

      timeSlotSequence: selectedBus.routes[0].timeSlot,
      departureTime:
        selectedBus.routes[0].journeyTiming.departureTime || "00:00:00",
      arrivalTime:
        selectedBus.routes[0].journeyTiming.arrivalTime || "00:00:00",
    };
    console.log("booking data", data);
    await localStorage.setItem("roam-booking", JSON.stringify(data));
    navigate("/payment");
  };
  return (
    <div style={{ width: mobile ? "100vw" : "100%" }}>
      <div
        style={{
          position: "fixed",
          top: showHeader ? "0" : "-80px", // hide smoothly
          left: 0,
          right: 0,
          transition: "top 0.3s ease-in-out",
          zIndex: 1000,
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          backdropFilter: "blur(10px)", // blur background
          background: "rgba(255, 255, 255, 0.3)", // transparent glass
          WebkitBackdropFilter: "blur(10px)", // for Safari
        }}
      >
        <Header />
      </div>

      <div
        style={{
          width: "100%",
          boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "130px",
          zIndex: 600,
          backgroundImage: "url('/Sliding/newyork-img.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div
        style={{
          position: "relative",
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            inset: 0,
            width: "150%",
            height: "110%",
            top: "-60px",
            objectFit: "cover",
            zIndex: -100,
          }}
        >
          <source src="/Sliding/bus-vid-2.mp4" type="video/mp4" />
        </video>
        <div
          style={{
            display: "flex",
            padding: mobile ? "10px" : "20px",
            gap: "14px",
            justifyContent: "space-between",
            flexDirection: mobile ? "column" : "row",
          }}
        >
          <div style={{ width: "100%", marginBottom: "10px" }}>
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="card"
              style={{
                borderRadius: "10px",
                padding: "12px",
                width: mobile ? "90vw" : "60vw",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                background: "rgba(255, 255, 255, 0.18)",
                backdropFilter: "blur(35px)",
                WebkitBackdropFilter: "blur(35px)",
                border: "1px solid rgba(255, 255, 255, 0.25)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 0px",
                  gap: mobile ? "10px" : "20px",
                }}
              >
                <div>
                  <p style={{ fontSize: "20px", fontWeight: "700" }}>
                    {bus?.primaryImage ? (
                      <img
                        src={`https://admin.roamjssln.com${bus?.primaryImage}`}
                        style={{ width: "80px", height: "80px" }}
                      />
                    ) : (
                      <img
                        src="/Assets/bus_10.png"
                        style={{ width: "80px", height: "80px" }}
                      />
                    )}
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    padding: "2px 20px",
                    width: "85%",
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: mobile ? "16px" : "24px",
                        fontWeight: "600",
                      }}
                    >
                      {truncateToWords(bus?.busName)}
                    </p>
                    <p
                      style={{
                        fontSize: mobile ? "10px" : "14px",
                        fontWeight: "400",
                        color: "gray",
                      }}
                    >
                      {bus?.busNumber} ({bus?.busType}/{bus?.busCategory})
                    </p>
                  </div>

                  <div>
                    <p
                      style={{
                        fontSize: mobile ? "15px" : "17px",
                        fontWeight: "600",
                      }}
                    >
                      {bus.routes[0].bookingStatus?.departureTime} -{" "}
                      {bus.routes[0].bookingStatus?.arrivalTime}
                    </p>
                    {/* <p style={{fontSize:"10px",fontWeight:"400"}}>{item.route?.additionalBoardingPoints[1]?.pickupTime} - {item.route?.additionalDroppingPoints[1]?.dropTime}</p> */}
                    {/* <p style={{fontSize:"10px",fontWeight:"400",color:"gray"}}>{bus.route.routeDetails?.estimatedDuration?.hours} hrs {bus.route?.routeDetails?.estimatedDuration?.minutes} mins</p> */}
                  </div>
                  <div>
                    <p
                      style={{
                        fontSize: mobile ? "15px" : "20px",
                        fontWeight: "700",
                      }}
                    >
                      Base price ₹{bus?.defaultRoute?.fareDetails?.basePrice}/-
                    </p>
                    <p
                      style={{
                        fontSize: mobile ? "7px" : "10px",
                        fontWeight: "600",
                        color: "#2f92c4",
                      }}
                    >
                      Total Distance{" "}
                      {bus?.defaultRoute?.routeDetails?.totalDistance} Km
                    </p>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {bus?.images.map((img) => (
                  <div
                    style={{
                      display: "flex",
                      width: "20%",
                      justifyContent: "start",
                      gap: "2px",
                    }}
                  >
                    <img
                      src={
                        bus?.images.length > 0
                          ? `https://admin.roamjssln.com${img}`
                          : "/Assets/bus_10.png"
                      }
                      style={{ width: "30px", height: "30px" }}
                    />
                  </div>
                ))}
                <div
                  style={{
                    display: "flex",
                    width: "80%",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: mobile ? "10px" : "14px",
                        fontWeight: "600",
                        padding: "3px",
                        borderRadius: "4px",
                        backgroundColor: "#b0dff7ff",
                        width: "fit-content",
                        color: "black",
                      }}
                    >
                      <img src="/Assets/star.png" style={{ width: "10px" }} />
                      <span>
                        {bus.routes[0]?.additionalBoardingPoints[0]?.city}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: mobile ? "10px" : "12px",
                        fontWeight: "600",
                        color: "gray",
                      }}
                    >
                      {bus.routes[0]?.additionalBoardingPoints[0]?.landmark}
                    </p>
                  </div>

                  <div>
                    <p
                      style={{
                        fontSize: mobile ? "10px" : "14px",
                        fontWeight: "600",
                        padding: "3px",
                        borderRadius: "4px",
                        backgroundColor: "#bdfcdfff",
                        width: "fit-content",
                        color: "black",
                      }}
                    >
                      <img src="/Assets/star.png" style={{ width: "10px" }} />
                      <span>
                        {bus.routes[0]?.additionalDroppingPoints?.at(-1)?.city}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: mobile ? "10px" : "12px",
                        fontWeight: "600",
                        color: "gray",
                      }}
                    >
                      {
                        bus.routes[0]?.additionalDroppingPoints?.at(-1)
                          ?.landmark
                      }
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            <div
              className="hide-scrollbar"
              style={{
                height: "120vh",
                paddingBottom: "20px",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: mobile ? "column" : "row",
                  gap: "10px",
                }}
              >
                <motion.div
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  className="card"
                  style={{
                    borderRadius: "10px",
                    padding: "12px",
                    width: mobile ? "90vw" : "30vw",
                    margin: "20px 0px",
                    background: "rgba(248, 243, 243, 0.52)",
                    backdropFilter: "blur(35px)",
                    WebkitBackdropFilter: "blur(35px)",
                    border: "1px solid rgba(255, 255, 255, 0.25)",
                  }}
                >
                  <p
                    style={{
                      fontSize: mobile ? "16px" : "22px",
                      fontWeight: "500",
                    }}
                  >
                    Route & Boarding Points (Onward)
                  </p>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          position: "relative",
                        }}
                      >
                        {/* TRACK LINE + DOT */}
                        <div
                          style={{
                            width: "30px",
                            display: "flex",
                            justifyContent: "center",
                            position: "relative",
                          }}
                        >
                          {/* Vertical line */}
                          {
                            <div
                              style={{
                                position: "absolute",
                                top: "45px",
                                height: "70px",
                                bottom: "0",
                                width: "2px",
                                backgroundColor: "#000000",
                              }}
                            />
                          }

                          {/* Green dot */}
                          <div>
                            <img
                              src="/Assets/bus-stop.png"
                              style={{
                                width: "30px",
                                height: "30px",
                                marginTop: "18px",
                                zIndex: 1,
                              }}
                            />
                          </div>
                        </div>

                        {/* CONTENT */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                            padding: "20px 10px",
                          }}
                        >
                          <div>
                            <p
                              style={{
                                fontSize: mobile ? "15px" : "18px",
                                fontWeight: "500",
                              }}
                            >
                              {bus.routes[0]?.additionalBoardingPoints[0]?.city}
                            </p>
                            <p
                              style={{
                                fontSize: mobile ? "10px" : "14px",
                                fontWeight: "500",
                              }}
                            >
                              {
                                bus.routes[0]?.additionalBoardingPoints[0]
                                  ?.landmark
                              }
                            </p>
                            <p
                              style={{
                                fontSize: mobile ? "7px" : "10px",
                                fontWeight: "500",
                              }}
                            >
                              (
                              {
                                bus.routes[0]?.additionalBoardingPoints[0]
                                  ?.address
                              }
                              )
                            </p>
                          </div>

                          <p
                            style={{
                              fontSize: mobile ? "16px" : "18px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                            }}
                          >
                            <img
                              src="/Assets/clock-ic.png"
                              style={{ width: "15px" }}
                            />{" "}
                            <span>
                              {bus.routes[0]?.bookingStatus?.departureTime}
                            </span>
                          </p>
                        </div>
                      </div>
                      {bus.routes[0].intermediateStops.map((i, ind) => (
                        <div
                          key={ind}
                          style={{
                            display: "flex",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          {/* TRACK LINE + DOT */}
                          <div
                            style={{
                              width: "30px",
                              display: "flex",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            {/* Vertical line */}
                            {
                              <div
                                style={{
                                  position: "absolute",
                                  top: "45px",
                                  height: "70px",
                                  bottom: "0",
                                  width: "2px",
                                  backgroundColor: "#000000",
                                }}
                              />
                            }

                            {/* Green dot */}
                            <div>
                              <img
                                src="/Assets/bus-stop.png"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  marginTop: "18px",
                                  zIndex: 1,
                                }}
                              />
                            </div>
                          </div>

                          {/* CONTENT */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignItems: "center",
                              padding: "20px 10px",
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontSize: mobile ? "15px" : "18px",
                                  fontWeight: "500",
                                }}
                              >
                                {i.city}
                              </p>
                              <p
                                style={{
                                  fontSize: mobile ? "10px" : "14px",
                                  fontWeight: "500",
                                }}
                              >
                                {i.landmark}
                              </p>
                              <p
                                style={{
                                  fontSize: mobile ? "7px" : "10px",
                                  fontWeight: "500",
                                }}
                              >
                                ({i.address})
                              </p>
                            </div>

                            <p
                              style={{
                                fontSize: mobile ? "16px" : "18px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "14px",
                              }}
                            >
                              <img
                                src="/Assets/clock-ic.png"
                                style={{ width: "15px" }}
                              />{" "}
                              <span>{i.arrivalTime}</span>
                            </p>
                          </div>
                        </div>
                      ))}

                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          position: "relative",
                        }}
                      >
                        {/* TRACK LINE + DOT */}
                        <div
                          style={{
                            width: "30px",
                            display: "flex",
                            justifyContent: "center",
                            position: "relative",
                          }}
                        >
                          {/* Vertical line (hide for last item) */}

                          {/* Green dot */}
                          <div>
                            <img
                              src="/Assets/bus-stop.png"
                              style={{
                                width: "30px",
                                height: "30px",
                                marginTop: "18px",
                                zIndex: 1,
                              }}
                            />
                          </div>
                        </div>

                        {/* CONTENT */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                            padding: "20px 10px",
                          }}
                        >
                          <div>
                            <p
                              style={{
                                fontSize: mobile ? "15px" : "18px",
                                fontWeight: "500",
                              }}
                            >
                              {
                                bus.routes[0]?.additionalDroppingPoints?.at(-1)
                                  ?.city
                              }
                            </p>
                            <p
                              style={{
                                fontSize: mobile ? "10px" : "14px",
                                fontWeight: "500",
                              }}
                            >
                              {
                                bus.routes[0]?.additionalDroppingPoints?.at(-1)
                                  ?.landmark
                              }
                            </p>
                            <p
                              style={{
                                fontSize: mobile ? "7px" : "10px",
                                fontWeight: "500",
                              }}
                            >
                              (
                              {
                                bus.routes[0]?.additionalDroppingPoints?.at(-1)
                                  ?.address
                              }
                              )
                            </p>
                          </div>

                          <p
                            style={{
                              fontSize: mobile ? "16px" : "18px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                            }}
                          >
                            <img
                              src="/Assets/clock-ic.png"
                              style={{ width: "15px" }}
                            />{" "}
                            <span>
                              {bus.routes[0]?.bookingStatus?.arrivalTime}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>

                {bus.routes.length > 1 && (
                  <motion.div
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="card"
                    style={{
                      borderRadius: "10px",
                      padding: "12px",
                      width: mobile ? "90vw" : "30vw",
                      margin: "20px 0px",
                      background: "rgba(248, 243, 243, 0.52)",
                      backdropFilter: "blur(35px)",
                      WebkitBackdropFilter: "blur(35px)",
                      border: "1px solid rgba(255, 255, 255, 0.25)",
                    }}
                  >
                    <p style={{ fontSize: "22px", fontWeight: "500" }}>
                      Route & Boarding Points (Return)
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          {/* TRACK LINE + DOT */}
                          <div
                            style={{
                              width: "30px",
                              display: "flex",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            {/* Vertical line */}
                            {
                              <div
                                style={{
                                  position: "absolute",
                                  top: "45px",
                                  height: "70px",
                                  bottom: "0",
                                  width: "2px",
                                  backgroundColor: "#000000",
                                }}
                              />
                            }

                            {/* Green dot */}
                            <div>
                              <img
                                src="/Assets/bus-stop.png"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  marginTop: "18px",
                                  zIndex: 1,
                                }}
                              />
                            </div>
                          </div>

                          {/* CONTENT */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignItems: "center",
                              padding: "20px 10px",
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontSize: mobile ? "15px" : "18px",
                                  fontWeight: "500",
                                }}
                              >
                                {
                                  bus.routes[1]?.additionalBoardingPoints[0]
                                    ?.city
                                }
                              </p>
                              <p
                                style={{
                                  fontSize: mobile ? "10px" : "14px",
                                  fontWeight: "500",
                                }}
                              >
                                {
                                  bus.routes[1]?.additionalBoardingPoints[0]
                                    ?.landmark
                                }
                              </p>
                              <p
                                style={{
                                  fontSize: mobile ? "7px" : "10px",
                                  fontWeight: "500",
                                }}
                              >
                                (
                                {
                                  bus.routes[1]?.additionalBoardingPoints[0]
                                    ?.address
                                }
                                )
                              </p>
                            </div>

                            <p
                              style={{
                                fontSize: mobile ? "16px" : "18px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "14px",
                              }}
                            >
                              <img
                                src="/Assets/clock-ic.png"
                                style={{ width: "15px" }}
                              />{" "}
                              <span>
                                {bus.routes[1]?.bookingStatus?.departureTime}
                              </span>
                            </p>
                          </div>
                        </div>

                        {bus.routes[1].intermediateStops.map((i, ind) => (
                          <div
                            key={ind}
                            style={{
                              display: "flex",
                              width: "100%",
                              position: "relative",
                            }}
                          >
                            {/* TRACK LINE + DOT */}
                            <div
                              style={{
                                width: "30px",
                                display: "flex",
                                justifyContent: "center",
                                position: "relative",
                              }}
                            >
                              {/* Vertical line */}
                              {
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "45px",
                                    height: "70px",
                                    bottom: "0",
                                    width: "2px",
                                    backgroundColor: "#000000",
                                  }}
                                />
                              }

                              {/* Green dot */}
                              <div>
                                <img
                                  src="/Assets/bus-stop.png"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    marginTop: "18px",
                                    zIndex: 1,
                                  }}
                                />
                              </div>
                            </div>

                            {/* CONTENT */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                                padding: "20px 10px",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    fontSize: mobile ? "15px" : "18px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {i.city}
                                </p>
                                <p
                                  style={{
                                    fontSize: mobile ? "10px" : "14px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {i.landmark}
                                </p>
                                <p
                                  style={{
                                    fontSize: mobile ? "7px" : "10px",
                                    fontWeight: "500",
                                  }}
                                >
                                  ({i.address})
                                </p>
                              </div>

                              <p
                                style={{
                                  fontSize: mobile ? "16px" : "18px",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "14px",
                                }}
                              >
                                <img
                                  src="/Assets/clock-ic.png"
                                  style={{ width: "15px" }}
                                />{" "}
                                <span>{i.arrivalTime}</span>
                              </p>
                            </div>
                          </div>
                        ))}

                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          {/* TRACK LINE + DOT */}
                          <div
                            style={{
                              width: "30px",
                              display: "flex",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            {/* Vertical line (hide for last item) */}

                            {/* Green dot */}
                            <div>
                              <img
                                src="/Assets/bus-stop.png"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  marginTop: "18px",
                                  zIndex: 1,
                                }}
                              />
                            </div>
                          </div>

                          {/* CONTENT */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignItems: "center",
                              padding: "20px 10px",
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontSize: mobile ? "15px" : "18px",
                                  fontWeight: "500",
                                }}
                              >
                                {
                                  bus.routes[1]?.additionalDroppingPoints?.at(
                                    -1,
                                  )?.city
                                }
                              </p>
                              <p
                                style={{
                                  fontSize: mobile ? "10px" : "14px",
                                  fontWeight: "500",
                                }}
                              >
                                {
                                  bus.routes[1]?.additionalDroppingPoints?.at(
                                    -1,
                                  )?.landmark
                                }
                              </p>
                              <p
                                style={{
                                  fontSize: mobile ? "7px" : "10px",
                                  fontWeight: "500",
                                }}
                              >
                                (
                                {
                                  bus.routes[1]?.additionalDroppingPoints?.at(
                                    -1,
                                  )?.address
                                }
                                )
                              </p>
                            </div>

                            <p
                              style={{
                                fontSize: mobile ? "16px" : "px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "14px",
                              }}
                            >
                              <img
                                src="/Assets/clock-ic.png"
                                style={{ width: "15px" }}
                              />{" "}
                              <span>
                                {bus.routes[1]?.bookingStatus?.arrivalTime}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </div>

              {bus.amenities.length > 1 && (
                <motion.div
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.2, ease: "easeOut" }}
                  className="card"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "white",
                    padding: "12px",
                    width: mobile ? "94vw" : "60vw",
                    margin: "20px 0px",
                    border: "0.3px solid rgba(235, 235, 235, 0.93)",
                    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <p style={{ fontSize: "20px", fontWeight: "600" }}>
                    Amenities & Features
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px",
                      padding: "20px",
                    }}
                  >
                    {bus.amenities.map((i) => (
                      <p
                        style={{
                          padding: "10px",
                          borderRadius: "6px",
                          backgroundColor: "#dddbdb",
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src="/Assets/a&f.png"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <span style={{ fontWeight: "600" }}>{i}</span>
                      </p>
                    ))}
                  </div>
                </motion.div>
              )}

              <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.2, ease: "easeOut" }}
                className="card"
                style={{
                  borderRadius: "14px",
                  backgroundColor: "white",
                  padding: mobile ? "18px" : "24px",
                  width: mobile ? "94vw" : "60vw",
                  margin: "20px 0px",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)",
                  boxShadow: "4px 4px 18px rgba(0, 0, 0, 0.12)",
                }}
              >
                <div>
                  {/* Heading */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "18px",
                    }}
                  >
                    <div
                      style={{
                        width: "5px",
                        height: "28px",
                        background: "#4f46e5",
                        borderRadius: "10px",
                      }}
                    />

                    <p
                      style={{
                        fontSize: mobile ? "19px" : "22px",
                        fontWeight: "700",
                        color: "#222",
                        margin: 0,
                      }}
                    >
                      Cancellation Policy & Rules
                    </p>
                  </div>

                  {/* Policy Rows */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "14px",
                    }}
                  >
                    {/* Cancellation */}
                    <div
                      style={{
                        background: "#fafafa",
                        padding: "14px 16px",
                        borderRadius: "10px",
                        border: "1px solid #efefef",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "6px",
                        }}
                      >
                        Cancellation Policy
                      </p>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#777",
                          margin: 0,
                          lineHeight: "24px",
                        }}
                      >
                        ❇️ {bookingPolicy?.cancellationPolicy}
                      </p>
                    </div>

                    {/* Refund */}
                    <div
                      style={{
                        background: "#fafafa",
                        padding: "14px 16px",
                        borderRadius: "10px",
                        border: "1px solid #efefef",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "6px",
                        }}
                      >
                        Refund Policy
                      </p>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#777",
                          margin: 0,
                          lineHeight: "24px",
                        }}
                      >
                        ❇️ {bookingPolicy?.refundPolicy}
                      </p>
                    </div>

                    {/* Child Ticket */}
                    <div
                      style={{
                        background: "#fafafa",
                        padding: "14px 16px",
                        borderRadius: "10px",
                        border: "1px solid #efefef",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "6px",
                        }}
                      >
                        Child Ticket Policy
                      </p>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#777",
                          margin: 0,
                          lineHeight: "24px",
                        }}
                      >
                        ❇️ {bookingPolicy?.childTicketPolicy}
                      </p>
                    </div>

                    {/* ID Proof */}
                    <div
                      style={{
                        background: "#fafafa",
                        padding: "14px 16px",
                        borderRadius: "10px",
                        border: "1px solid #efefef",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "6px",
                        }}
                      >
                        ID Proof Requirement
                      </p>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#777",
                          margin: 0,
                          lineHeight: "24px",
                        }}
                      >
                        ❇️ {bookingPolicy?.idProofRequirement}
                      </p>
                    </div>

                    {/* Terms */}
                    <div
                      style={{
                        background: "#f8f8f8",
                        padding: "16px",
                        borderRadius: "10px",
                        border: "1px dashed #dcdcdc",
                        marginTop: "6px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#222",
                          marginBottom: "10px",
                        }}
                      >
                        Terms & Conditions
                      </p>

                      <p
                        style={{
                          fontSize: "14px",
                          color: "#757575",
                          lineHeight: "26px",
                          margin: 0,
                        }}
                      >
                        {bookingPolicy?.termsAndConditions}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          <motion.div
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="card"
            style={{
              borderRadius: "10px",
              backgroundColor: "white",
              padding: "16px",
              width: mobile ? "94vw" : "38vw",
              height: "fit-content",
              background: "rgba(255, 255, 255, 0.18)",
              backdropFilter: "blur(35px)",
              WebkitBackdropFilter: "blur(35px)",
              border: "1px solid rgba(255, 255, 255, 0.25)",
            }}
          >
            <p style={{ fontSize: "20px", fontWeight: "500" }}>
              Booking Type for this journey
            </p>
            <p style={{ fontSize: "16px", color: "grey" }}>
              {bookingType === "regular"
                ? "Booking type is prebooking so user can select seats"
                : "Bus already departed so instant booking without seat selection is available"}
            </p>
            <p style={{ fontWeight: "600", color: "#118cdf" }}>
              {bus?.bookingStatus?.status}
            </p>

            {bookingType === "regular" && (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px",
                  border:
                    bookingType === "regular"
                      ? "0.6px solid #0f9dfc"
                      : "0.6px solid #dfdfdf",
                  borderRadius: "8px",
                  width: "50%",
                  margin: "20px 10px",
                  backgroundColor: bookingType === "regular" ? "#cce8fa" : "",
                }}
              >
                <input
                  type="radio"
                  name="bookingType"
                  value="regular"
                  checked={bookingType === "regular"}
                />
                <div>
                  <p style={{ fontSize: "16px", fontWeight: "600" }}>Booking</p>
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "600",
                      color: "#aaaaaa",
                    }}
                  >
                    Select your preffered seats based on avaibility, choose
                    specific seat number
                  </p>
                </div>
              </label>
            )}

            {bookingType === "instant" && (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px",
                  border:
                    bookingType === "instant"
                      ? "0.6px solid #0f9dfc"
                      : "0.6px solid #dfdfdf",
                  borderRadius: "8px",
                  width: "50%",
                  margin: "20px 10px",
                  backgroundColor: bookingType === "instant" ? "#cce8fa" : "",
                }}
              >
                <input
                  type="radio"
                  name="bookingType"
                  value="instant"
                  checked={bookingType === "instant"}
                />
                <div>
                  <p style={{ fontSize: "16px", fontWeight: "600" }}>
                    Instant Booking
                  </p>
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "600",
                      color: "#aaaaaa",
                    }}
                  >
                    Book instantly without seat selection
                  </p>
                </div>
              </label>
            )}

            {bookingType === "completed" && (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px",
                  border:
                    bookingType === "instant"
                      ? "0.6px solid #0f9dfc"
                      : "0.6px solid #dfdfdf",
                  borderRadius: "8px",
                  width: "50%",
                  margin: "20px 10px",
                  backgroundColor: bookingType === "completed" ? "#9e9e9e" : "",
                }}
              >
                <div>
                  <p style={{ fontSize: "16px", fontWeight: "600" }}>
                    Journey Completed
                  </p>
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "600",
                      color: "#272727",
                    }}
                  >
                    Seat Booking is not availabe now{" "}
                  </p>
                </div>
              </label>
            )}

            <p style={{ fontWeight: "600" }}>{bus?.bookingStatus?.message}</p>
            <p style={{ fontWeight: "600", fontSize: "12px", padding: "16px" }}>
              {bus?.bookingStatus?.note}
            </p>

            {bookingType === "regular" && (
              <div style={{ display: "flex", gap: "10px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px",
                    border:
                      tripType === "oneWay"
                        ? "0.6px solid #0f9dfc"
                        : "0.6px solid #dfdfdf",
                    borderRadius: "8px",
                    width: "50%",
                    margin: "20px 10px",
                    backgroundColor: tripType === "oneWay" ? "#cce8fa" : "",
                  }}
                >
                  <input
                    type="radio"
                    name="tripType"
                    value="oneWay"
                    checked={tripType === "oneWay"}
                    onChange={(e) => setTripType(e.target.value)}
                  />
                  <div>
                    <p style={{ fontSize: "12px", fontWeight: "600" }}>
                      One way Booking
                    </p>
                  </div>
                </label>

                {bus.routes.length > 1 && (
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "6px",
                      border:
                        tripType === "round"
                          ? "0.6px solid #0f9dfc"
                          : "0.6px solid #dfdfdf",
                      borderRadius: "8px",
                      width: "50%",
                      margin: "20px 10px",
                      backgroundColor: tripType === "round" ? "#cce8fa" : "",
                    }}
                  >
                    <input
                      type="radio"
                      name="tripType"
                      value="round"
                      checked={tripType === "round"}
                      onChange={(e) => setTripType(e.target.value)}
                    />
                    <div>
                      <p style={{ fontSize: "12px", fontWeight: "600" }}>
                        Round Booking
                      </p>
                    </div>
                  </label>
                )}
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "6px",
                padding: "6px",
                borderRadius: "8px",
                width: "80%",
                margin: "20px 10px",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  color: "#858383",
                  fontWeight: "500",
                }}
              >
                Total seats
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "#1a1a1a",
                  fontWeight: "600",
                }}
              >
                {" "}
                {bus?.totalSeats}
              </p>
            </div>

            {/* <div style={{ display: "flex",justifyContent:"space-between", alignItems: "center", gap: "6px" ,padding:"6px" ,
                                      borderRadius:"8px",width:"80%",margin:"20px 10px",}}>
                                        <p style={{fontSize:"14px",color:"#858383",fontWeight:"500"}}>Base Fare</p>
                                        <p style={{fontSize:"14px",color:"#1a1a1a",fontWeight:"600"}}>{bus.fareDetails.basePrice}</p>

                                      </div> */}
            {bookingType === "completed" ? (
              <p
                onClick={() => navigate("/bus-booking")}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "pointer",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px",
                  borderRadius: "8px",
                  width: "80%",
                  margin: "20px 10px",
                  textAlign: "center",
                  backgroundColor: "#0f89fc",
                  color: "white",
                  fontWeight: "600",
                }}
              >
                Journey Complete
              </p>
            ) : (
              <p
                onClick={() => {
                  tripType === "oneWay"
                    ? setMainModal(true)
                    : setRoundModal(true);
                }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "pointer",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px",
                  borderRadius: "8px",
                  width: "80%",
                  margin: "20px 10px",
                  textAlign: "center",
                  backgroundColor: "#0f89fc",
                  color: "white",
                  fontWeight: "600",
                }}
              >
                {bookingType === "instant" ? "Proceed" : "Select Seat"}
              </p>
            )}
          </motion.div>
        </div>
      </div>

      <Footer />

      {mainModal && (
        <motion.div
          initial={{ y: 500, opacity: 1 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            duration: 0.4,
            ease: "easeIn",
          }}
          style={{
            boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
            position: "fixed",
            top: "10vh",
            backgroundColor: "white",
            zIndex: 9900,
            borderRadius: "15px",
            width: "100%",
            height: "100vh",
            maxHeight: "130vh",
            overflow: "hidden",
          }}
        >
          {
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "40px",
                padding: "10px",
                borderBottom: "1px solid gray",
              }}
            >
              <p
                style={{ cursor: "pointer", fontSize: "22px" }}
                onClick={() => setMainModal(false)}
              >
                X
              </p>
              <p
                style={{
                  fontSize: mobile ? "15px" : "20px",
                  fontWeight: "700",
                }}
              >
                Select seats and locations
              </p>
            </div>
          }

          {mobile ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: mobile ? "column" : "row",
                paddingLeft: "10%",
                paddingRight: "10%",
                height: "100dvh",
                width: "90%",
                background: "#ffffff",
                overflowY: "auto",
                overflowX: "hidden",
                WebkitOverflowScrolling: "touch",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "15px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  background: "#ffffff",
                  maxHeight: "100%",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: "100%",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                {bookingType === "regular" ? (
                  <BusSeatLayout seats={seats} busType={busType} />
                ) : (
                  <div>
                    <p
                      style={{
                        padding: "30px",
                        fontSize: "26px",
                        fontWeight: "700",
                        color: "grey",
                      }}
                    >
                      Seat selection option is not availabe in instant booking
                    </p>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <label>
                        <select
                          style={{
                            padding: "16px",
                            outline: "none",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#646363",
                          }}
                          value={instantPassengers}
                          onChange={(e) => setInstantPassengers(e.target.value)}
                        >
                          <option value={0}>Select number of passenger</option>
                          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                            <option value={i}>{i} passenger</option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  background: "#ffffff",
                  minHeight: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "30px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                <div>
                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "pickup"
                          ? setModalMode("")
                          : setModalMode("pickup");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {boardingPointName
                          ? boardingPointName
                          : "Select Pickup-points"}
                      </span>
                      <span>
                        {modalMode === "pickup" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "14px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "pickup" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {selectedBus.routes[0]?.additionalBoardingPoints.map(
                          (i, ind) => (
                            <div
                              onClick={() => {
                                setBoardingPoint(i._id);
                                setBoardingPointName(i.name);
                                setCurrentPickup(
                                  selectedBus.routes[0]?.fareMatrix[ind],
                                );
                                setModalMode("");
                              }}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "fit-content",
                                border: "0.3px solid gray",
                                fontSize: "10px",
                                backgroundColor:
                                  boardingPoint === i._id
                                    ? "rgb(2, 40, 83)"
                                    : "white",
                                color:
                                  boardingPoint === i._id
                                    ? "rgb(255, 255, 255)"
                                    : "black",
                                borderRadius: "10px",
                                margin: "6px",
                              }}
                            >
                              <p style={{ fontWeight: "700" }}>{i.name}</p>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>

                  <div style={{ cursor: "pointer" }}>
                    <p
                      onClick={() => {
                        modalMode === "dropping"
                          ? setModalMode("")
                          : setModalMode("dropping");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {droppingPointName
                          ? droppingPointName
                          : "Select Drop-points"}
                      </span>
                      <span>
                        {modalMode === "dropping" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "15px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "dropping" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {selectedBus.routes[0]?.additionalDroppingPoints.map(
                          (i) => (
                            <div
                              onClick={() => {
                                setDroppingPoint(i?._id);
                                handleFareCalculation(i?.name);
                                setDroppingPointName(i?.name);
                                setModalMode("");
                              }}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "fit-content",
                                border: "0.3px solid gray",
                                fontSize: "10px",
                                backgroundColor:
                                  droppingPoint === i._id
                                    ? "rgb(2, 40, 83)"
                                    : "white",
                                color:
                                  droppingPoint === i._id
                                    ? "rgb(255, 255, 255)"
                                    : "black",
                                borderRadius: "10px",
                                margin: "6px",
                              }}
                            >
                              <p style={{ fontWeight: "700" }}>{i.name}</p>
                            </div>
                          ),
                        )}
                        <div
                          onClick={() => {
                            setDroppingPoint(
                              selectedBus.routes[0]?.additionalDroppingPoints[0]
                                ?._id,
                            );
                            handleFareCalculation("destination");
                            setDroppingPointName(
                              selectedBus.routes[0]?.additionalDroppingPoints[0]
                                ?.name,
                            );
                          }}
                          style={{
                            padding: "8px",
                            width: "70%",
                            height: "fit-content",
                            border: "0.3px solid gray",
                            fontSize: "10px",
                            backgroundColor:
                              droppingPoint ===
                              selectedBus.routes[0]?.additionalDroppingPoints[0]
                                ?._id
                                ? "rgb(2, 40, 83)"
                                : "white",
                            color:
                              droppingPoint ===
                              selectedBus.routes[0]?.additionalDroppingPoints[0]
                                ?._id
                                ? "rgb(255, 255, 255)"
                                : "black",
                            borderRadius: "10px",
                            margin: "6px",
                          }}
                        >
                          <p style={{ fontWeight: "700" }}>
                            {
                              selectedBus.routes[0]?.additionalDroppingPoints[0]
                                ?.name
                            }
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    margin: "3px",
                    backgroundColor: "white",
                    boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {bookingType === "regular" ? (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <p style={{ fontWeight: "700" }}>Selected Seats</p>
                        <p>x{selectedSeats.length}</p>
                      </div>
                    ) : (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <p style={{ fontWeight: "700" }}>
                          Number fo Passengers
                        </p>
                        <p>x{instantPassengers}</p>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        fontWeight: "600",
                        color: "grey",
                      }}
                    >
                      <p>Base fare ₹{selectedBus.fareDetails.basePrice} /-</p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                    }}
                  >
                    <p style={{ color: "#489dbeff", fontWeight: "700" }}>
                      Total Distance
                    </p>

                    <p>{calcDistance} Km</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                    }}
                  >
                    <p style={{ color: "#489dbeff", fontWeight: "700" }}>
                      Total Cost
                    </p>
                    {bookingType === "regular" ? (
                      <p>₹{calcFare * selectedSeats.length} /-</p>
                    ) : (
                      <p>₹{calcFare * instantPassengers} /-</p>
                    )}
                  </div>
                  <p
                    onClick={handleConfirmBooking}
                    style={{
                      width: "100%",
                      backgroundColor: "#489dbeff",
                      padding: "3px",
                      color: "white",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                  >
                    Continue
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "1%",
                paddingRight: "1%",
                height: "70%",
                width: "96vw",
                background: "#ffffff",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "15px",
                  alignItems: "center",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  background: "#ffffff",
                  maxHeight: "100%",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: "60%",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                {bookingType === "regular" ? (
                  <BusSeatLayout seats={seats} busType={busType} />
                ) : (
                  <div>
                    <p
                      style={{
                        padding: "30px",
                        fontSize: "26px",
                        fontWeight: "700",
                        color: "grey",
                      }}
                    >
                      Seat selection option is not availabe in instant booking
                    </p>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <label>
                        <select
                          style={{
                            padding: "16px",
                            outline: "none",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#646363",
                          }}
                          value={instantPassengers}
                          onChange={(e) => setInstantPassengers(e.target.value)}
                        >
                          <option value={0}>Select number of passenger</option>
                          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                            <option value={i}>{i} passenger</option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  position: "relative",
                  flex: 1,
                  background: "#ffffff",
                  minHeight: "90vh",
                  maxHeight: "130vh",
                  overflowY: "scroll",
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "20px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                <div>
                  <div
                    style={{
                      margin: "10px",
                      padding: "12px",
                      borderRadius: "6px",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                    }}
                  >
                    <p style={{ fontSize: "16px", fontWeight: "600" }}>
                      Trip Details
                    </p>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p style={{ fontSize: "16px", fontWeight: "700" }}>
                          {bus.routes[0].origin.city} to{" "}
                          {bus.routes[0].destination.city}
                        </p>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#757575",
                          }}
                        >
                          {bus.routes[0].origin.departureTime}----
                          {bus.routes[0].destination.arrivalTime}
                        </p>
                      </div>
                      <div>
                        <p style={{ fontSize: "16px", fontWeight: "700" }}>
                          {bus.busName}
                        </p>
                        <p style={{ fontSize: "16px", fontWeight: "700" }}>
                          {bus.busNumber}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      margin: "10px",
                      padding: "6px",
                      borderRadius: "6px",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "pickup"
                          ? setModalMode("")
                          : setModalMode("pickup");
                      }}
                      style={{
                        fontSize: "14px",
                        padding: "12px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {boardingPointName
                          ? boardingPointName
                          : "Select Pickup-points"}
                      </span>
                      <span>
                        {modalMode === "pickup" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "14px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "pickup" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {bookingType === "instant" ? (
                          <div>
                            <div
                              onClick={() => {
                                setBoardingPoint(
                                  selectedBus.routes[0]
                                    ?.additionalBoardingPoints[0]._id,
                                );
                                setBoardingPointName(
                                  selectedBus.routes[0]
                                    ?.additionalBoardingPoints[0].name,
                                );
                                setCurrentPickup(
                                  selectedBus.routes[0]?.fareMatrix[0],
                                );
                                setModalMode("");
                              }}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "fit-content",
                                border: "0.3px solid gray",
                                fontSize: "10px",
                                backgroundColor:
                                  boardingPoint ===
                                  selectedBus.routes[0]
                                    ?.additionalBoardingPoints[0]._id
                                    ? "rgb(2, 40, 83)"
                                    : "white",
                                color:
                                  boardingPoint ===
                                  selectedBus.routes[0]
                                    ?.additionalBoardingPoints[0]._id
                                    ? "rgb(255, 255, 255)"
                                    : "black",
                                borderRadius: "10px",
                                margin: "6px",
                              }}
                            >
                              <p style={{ fontWeight: "700" }}>
                                {
                                  selectedBus.routes[0]
                                    ?.additionalBoardingPoints[0].name
                                }
                              </p>
                            </div>
                            {selectedBus.routes[0]?.intermediateStops.map(
                              (i, ind) => (
                                <div
                                  onClick={() => {
                                    setBoardingPoint(i._id);
                                    setBoardingPointName(i.city);
                                    setCurrentPickup(
                                      selectedBus.routes[0]?.fareMatrix[ind],
                                    );
                                    setModalMode("");
                                  }}
                                  style={{
                                    padding: "8px",
                                    width: "70%",
                                    height: "fit-content",
                                    border: "0.3px solid gray",
                                    fontSize: "10px",
                                    backgroundColor:
                                      boardingPoint === i._id
                                        ? "rgb(2, 40, 83)"
                                        : "white",
                                    color:
                                      boardingPoint === i._id
                                        ? "rgb(255, 255, 255)"
                                        : "black",
                                    borderRadius: "10px",
                                    margin: "6px",
                                  }}
                                >
                                  <p style={{ fontWeight: "700" }}>{i.city}</p>
                                  <p style={{ fontWeight: "500" }}>
                                    {i.address} {i.arrivalTime}
                                  </p>
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          selectedBus.routes[0]?.additionalBoardingPoints.map(
                            (i, ind) => (
                              <div
                                onClick={() => {
                                  setBoardingPoint(i._id);
                                  setBoardingPointName(i.name);
                                  setCurrentPickup(
                                    selectedBus.routes[0]?.fareMatrix.find(
                                      (t) => t.fromName === i.city,
                                    ),
                                  );
                                  setModalMode("");
                                  setDroppingPoint("");
                                  setDroppingPointName("");
                                }}
                                style={{
                                  padding: "8px",
                                  width: "70%",
                                  height: "fit-content",
                                  border: "0.3px solid gray",
                                  fontSize: "10px",
                                  backgroundColor:
                                    boardingPoint === i._id
                                      ? "rgb(2, 40, 83)"
                                      : "white",
                                  color:
                                    boardingPoint === i._id
                                      ? "rgb(255, 255, 255)"
                                      : "black",
                                  borderRadius: "10px",
                                  margin: "6px",
                                }}
                              >
                                <p style={{ fontWeight: "700" }}>{i.name}</p>
                                <p style={{ fontWeight: "500" }}>
                                  {i.city} {i.pickupTime}
                                </p>
                              </div>
                            ),
                          )
                        )}
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      margin: "10px",
                      padding: "6px",
                      borderRadius: "6px",
                    }}
                  >
                    <p
                      onClick={() => {
                        if (!currentPickup) {
                          toast.info("Select pickup point first");
                          return;
                        }
                        modalMode === "dropping"
                          ? setModalMode("")
                          : setModalMode("dropping");
                      }}
                      style={{
                        fontSize: "14px",
                        padding: "12px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {droppingPointName
                          ? droppingPointName
                          : "Select Drop-points"}
                      </span>
                      <span>
                        {modalMode === "dropping" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "15px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "dropping" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {bookingType === "instant" ? (
                          <div>
                            {selectedBus.routes[0]?.intermediateStops.map(
                              (i, ind) => (
                                <div
                                  onClick={() => {
                                    setDroppingPoint(i._id);
                                    handleFareCalculation(
                                      i.city,
                                      i.city,
                                      i._id,
                                    );
                                    setDroppingPointName(i.city);
                                    setModalMode("");
                                  }}
                                  style={{
                                    padding: "8px",
                                    width: "70%",
                                    height: "fit-content",
                                    border: "0.3px solid gray",
                                    fontSize: "10px",
                                    backgroundColor:
                                      droppingPoint === i._id
                                        ? "rgb(2, 40, 83)"
                                        : "white",
                                    color:
                                      droppingPoint === i._id
                                        ? "rgb(255, 255, 255)"
                                        : "black",
                                    borderRadius: "10px",
                                    margin: "6px",
                                  }}
                                >
                                  <p style={{ fontWeight: "700" }}>{i.city}</p>
                                  <p style={{ fontWeight: "500" }}>
                                    {i.address} {i.arrivalTime}
                                  </p>
                                </div>
                              ),
                            )}
                            <div
                              onClick={() => {
                                setDroppingPoint(
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]._id,
                                );
                                setDroppingPointName(
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0].name,
                                );
                                handleFareCalculation(
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0].name,
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0].city,
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0].id,
                                );
                                setModalMode("");
                              }}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "fit-content",
                                border: "0.3px solid gray",
                                fontSize: "10px",
                                backgroundColor:
                                  droppingPoint ===
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]._id
                                    ? "rgb(2, 40, 83)"
                                    : "white",
                                color:
                                  droppingPoint ===
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]._id
                                    ? "rgb(255, 255, 255)"
                                    : "black",
                                borderRadius: "10px",
                                margin: "6px",
                              }}
                            >
                              <p style={{ fontWeight: "700" }}>
                                {
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0].name
                                }
                              </p>
                            </div>
                          </div>
                        ) : (
                          selectedBus.routes[0]?.additionalDroppingPoints.map(
                            (i) => (
                              <div
                                onClick={() => {
                                  setDroppingPoint(i._id);
                                  handleFareCalculation(i.name, i.city, i.id);
                                  setDroppingPointName(i.name);
                                  setModalMode("");
                                }}
                                style={{
                                  padding: "8px",
                                  width: "70%",
                                  height: "fit-content",
                                  border: "0.3px solid gray",
                                  fontSize: "10px",
                                  backgroundColor:
                                    droppingPoint === i._id
                                      ? "rgb(2, 40, 83)"
                                      : "white",
                                  color:
                                    droppingPoint === i._id
                                      ? "rgb(255, 255, 255)"
                                      : "black",
                                  borderRadius: "10px",
                                  margin: "6px",
                                }}
                              >
                                <p style={{ fontWeight: "700" }}>{i.name}</p>
                                <p style={{ fontWeight: "500" }}>
                                  {i.city} {i.dropTime}
                                </p>
                              </div>
                            ),
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    margin: "3px",
                    backgroundColor: "white",
                    boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    {bookingType === "regular" ? (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <p style={{ fontWeight: "700" }}>Selected Seats</p>
                        <p>x{selectedSeats.length}</p>
                      </div>
                    ) : (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <p style={{ fontWeight: "700" }}>
                          Number fo Passengers
                        </p>
                        <p>x{instantPassengers}</p>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        fontWeight: "600",
                        color: "grey",
                      }}
                    >
                      <p>Base fare ₹{selectedBus.fareDetails.basePrice} /-</p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <p style={{ color: "#489dbeff", fontWeight: "700" }}>
                      Total Distance
                    </p>

                    <p>{calcDistance} Km</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <p style={{ color: "#489dbeff", fontWeight: "700" }}>
                      Total Cost
                    </p>
                    {
                      <p>
                        {calcFare}X
                        {bookingType === "regular"
                          ? selectedSeats.length
                          : instantPassengers}
                      </p>
                    }
                    {bookingType === "regular" ? (
                      <p>₹{calcFare * selectedSeats.length} /-</p>
                    ) : (
                      <p>₹{calcFare * instantPassengers} /-</p>
                    )}
                  </div>
                  <p
                    onClick={handleConfirmBooking}
                    style={{
                      width: "100%",
                      backgroundColor: "#489dbeff",
                      padding: "3px",
                      color: "white",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                  >
                    Continue
                  </p>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      )}

      {roundModal && (
        <motion.div
          initial={{ y: 500, opacity: 1 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            duration: 0.4,
            ease: "easeIn",
          }}
          style={{
            boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
            position: "fixed",
            top: "10vh",
            backgroundColor: "white",
            zIndex: 900,
            borderRadius: "15px",
            height: mobile ? "70vh" : "110%",
            width: "100%",
            minHeight: "fit-content",
            overflowY: "auto",
          }}
        >
          {
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "40px",
                padding: "10px",
                borderBottom: "1px solid gray",
              }}
            >
              <p
                style={{ cursor: "pointer", fontSize: "22px" }}
                onClick={() => setRoundModal(false)}
              >
                X
              </p>
              <p
                style={{
                  fontSize: mobile ? "15px" : "20px",
                  fontWeight: "700",
                }}
              >
                Select seats and locations for {direction}
              </p>
            </div>
          }

          {mobile ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: mobile ? "column" : "row",
                paddingLeft: "10%",
                paddingRight: "10%",
                height: "100vh",
                width: "90%",
                background: "#ffffff",
                overflowY: "auto",
                overflowX: "hidden",
                WebkitOverflowScrolling: "touch",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "15px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  background: "#ffffff",
                  minHeight: "fit-content",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: "100%",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                {bookingType === "regular" ? (
                  <BusSeatLayout seats={seats} busType={busType} />
                ) : (
                  <p
                    style={{
                      padding: "30px",
                      fontSize: "26px",
                      fontWeight: "700",
                      color: "grey",
                    }}
                  >
                    Seat selection option is not availabe in instant booking
                  </p>
                )}
              </div>
              <div
                style={{
                  background: "#ffffff",
                  minHeight: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "30px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                <div>
                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "pickup"
                          ? setModalMode("")
                          : setModalMode("pickup");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {boardingPointName
                          ? boardingPointName
                          : "Select Pickup-points"}
                      </span>
                      <span>
                        {modalMode === "pickup" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "14px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "pickup" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {direction === "UP"
                          ? selectedBus.routes[0]?.fareMatrix.map((i) => (
                              <div
                                onClick={() => {
                                  setBoardingPoint(i.fromId);
                                  setBoardingPointName(i.fromName);
                                  setCurrentPickup(i);
                                  setModalMode("");
                                }}
                                style={{
                                  padding: "8px",
                                  width: "70%",
                                  height: "fit-content",
                                  border: "0.3px solid gray",
                                  fontSize: "10px",
                                  backgroundColor:
                                    boardingPoint === i.fromId
                                      ? "rgb(2, 40, 83)"
                                      : "white",
                                  color:
                                    boardingPoint === i.fromId
                                      ? "rgb(255, 255, 255)"
                                      : "black",
                                  borderRadius: "10px",
                                  margin: "6px",
                                }}
                              >
                                <p style={{ fontWeight: "700" }}>
                                  {i.fromName}
                                </p>
                              </div>
                            ))
                          : selectedBus.routes[1]?.fareMatrix.map((i) => (
                              <div
                                onClick={() => {
                                  setBoardingPoint(i.fromId);
                                  setBoardingPointName(i.fromName);
                                  setCurrentPickup(i);
                                  setModalMode("");
                                }}
                                style={{
                                  padding: "8px",
                                  width: "70%",
                                  height: "fit-content",
                                  border: "0.3px solid gray",
                                  fontSize: "10px",
                                  backgroundColor:
                                    boardingPoint === i.fromId
                                      ? "rgb(2, 40, 83)"
                                      : "white",
                                  color:
                                    boardingPoint === i.fromId
                                      ? "rgb(255, 255, 255)"
                                      : "black",
                                  borderRadius: "10px",
                                  margin: "6px",
                                }}
                              >
                                <p style={{ fontWeight: "700" }}>
                                  {i.fromName}
                                </p>
                              </div>
                            ))}
                      </div>
                    )}
                  </div>

                  <div style={{ cursor: "pointer" }}>
                    <p
                      onClick={() => {
                        modalMode === "dropping"
                          ? setModalMode("")
                          : setModalMode("dropping");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {droppingPointName
                          ? droppingPointName
                          : "Select Drop-points"}
                      </span>
                      <span>
                        {modalMode === "dropping" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "15px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "dropping" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {direction === "UP" ? (
                          <div>
                            {selectedBus.routes[0]?.fareMatrix.map((i) => (
                              <div
                                onClick={() => {
                                  setDroppingPoint(i?.fromId);
                                  handleFareCalculation(i?.fromId);
                                  setDroppingPointName(i?.fromName);
                                  setModalMode("");
                                }}
                                style={{
                                  padding: "8px",
                                  width: "70%",
                                  height: "fit-content",
                                  border: "0.3px solid gray",
                                  fontSize: "10px",
                                  backgroundColor:
                                    droppingPoint === i?.fromId
                                      ? "rgb(2, 40, 83)"
                                      : "white",
                                  color:
                                    droppingPoint === i?.fromId
                                      ? "rgb(255, 255, 255)"
                                      : "black",
                                  borderRadius: "10px",
                                  margin: "6px",
                                }}
                              >
                                <p style={{ fontWeight: "700" }}>
                                  {i?.fromName}
                                </p>
                              </div>
                            ))}

                            <div
                              onClick={() => {
                                setDroppingPoint(
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]?._id,
                                );
                                handleFareCalculation("destination");
                                setDroppingPointName(
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]?.name,
                                );
                                setModalMode("");
                              }}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "fit-content",
                                border: "0.3px solid gray",
                                fontSize: "10px",
                                backgroundColor:
                                  droppingPoint ===
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]?._id
                                    ? "rgb(2, 40, 83)"
                                    : "white",
                                color:
                                  droppingPoint ===
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]?._id
                                    ? "rgb(255, 255, 255)"
                                    : "black",
                                borderRadius: "10px",
                                margin: "6px",
                              }}
                            >
                              <p style={{ fontWeight: "700" }}>
                                {
                                  selectedBus.routes[0]
                                    ?.additionalDroppingPoints[0]?.name
                                }
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div>
                            {selectedBus.routes[1]?.fareMatrix.map((i) => (
                              <div
                                onClick={() => {
                                  setDroppingPoint(i.fromId);
                                  handleFareCalculation(i.fromId);
                                  setDroppingPointName(i.fromName);
                                  setModalMode("");
                                }}
                                style={{
                                  padding: "8px",
                                  width: "70%",
                                  height: "fit-content",
                                  border: "0.3px solid gray",
                                  fontSize: "10px",
                                  backgroundColor:
                                    droppingPoint === i.fromId
                                      ? "rgb(2, 40, 83)"
                                      : "white",
                                  color:
                                    droppingPoint === i.fromId
                                      ? "rgb(255, 255, 255)"
                                      : "black",
                                  borderRadius: "10px",
                                  margin: "6px",
                                }}
                              >
                                <p style={{ fontWeight: "700" }}>
                                  {i.fromName}
                                </p>
                              </div>
                            ))}

                            <div
                              onClick={() => {
                                setDroppingPoint(
                                  selectedBus.routes[1]
                                    ?.additionalDroppingPoints[0]?._id,
                                );
                                handleFareCalculation("destination");
                                setDroppingPointName(
                                  selectedBus.routes[1]
                                    ?.additionalDroppingPoints[0]?.name,
                                );
                                setModalMode("");
                              }}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "fit-content",
                                border: "0.3px solid gray",
                                fontSize: "10px",
                                backgroundColor:
                                  droppingPoint ===
                                  selectedBus.routes[1]
                                    ?.additionalDroppingPoints[0]?._id
                                    ? "rgb(2, 40, 83)"
                                    : "white",
                                color:
                                  droppingPoint ===
                                  selectedBus.routes[1]
                                    ?.additionalDroppingPoints[0]?._id
                                    ? "rgb(255, 255, 255)"
                                    : "black",
                                borderRadius: "10px",
                                margin: "6px",
                              }}
                            >
                              <p style={{ fontWeight: "700" }}>
                                {
                                  selectedBus.routes[1]
                                    ?.additionalDroppingPoints[0]?.name
                                }
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    margin: "6px",
                    backgroundColor: "white",
                    boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ display: "flex", gap: "10px" }}>
                      <p style={{ fontWeight: "700", margin: 0 }}>
                        Selected Seats
                      </p>
                      <p style={{ margin: 0 }}>x{selectedSeats.length}</p>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <p style={{ margin: 0 }}>
                        ₹
                        {selectedBus.fareDetails.basePrice *
                          selectedSeats.length}{" "}
                        /-
                      </p>
                      <p
                        style={{
                          color: "#489dbeff",
                          fontWeight: "700",
                          margin: 0,
                        }}
                      >
                        Fare Details
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                    }}
                  >
                    <p
                      style={{
                        color: "#489dbeff",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      Total Distabce
                    </p>
                    <p style={{ margin: 0 }}>{calcDistance} Km</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                    }}
                  >
                    <p
                      style={{
                        color: "#489dbeff",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      Total Cost
                    </p>
                    <p style={{ fontWeight: "600", fontSize: "14px" }}>
                      Onward:{upDetails?.fare}/- Return:
                      {direction === "DOWN" && calcFare}/-
                    </p>
                    <p style={{ margin: 0 }}>
                      ₹
                      {direction === "UP"
                        ? calcFare * selectedSeats.length
                        : (upDetails?.fare + calcFare) *
                          selectedSeats.length}{" "}
                      /-
                    </p>
                  </div>
                  <p
                    onClick={() => {
                      direction === "UP"
                        ? handleUpConform()
                        : handleRoundConformBooking();
                    }}
                    style={{
                      width: "100%",
                      backgroundColor: "#489dbeff",
                      padding: "3px",
                      color: "white",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                  >
                    {direction === "UP" ? "Select for Down" : "Continue"}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "1%",
                paddingRight: "1%",
                height: "70%",
                width: "96vw",
                background: "#ffffff",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "15px",
                  alignItems: "center",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  background: "#ffffff",
                  maxHeight: "100%",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: "60%",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                {bookingType === "regular" ? (
                  <BusSeatLayout seats={seats} busType={busType} />
                ) : (
                  <p
                    style={{
                      padding: "30px",
                      fontSize: "26px",
                      fontWeight: "700",
                      color: "grey",
                    }}
                  >
                    Seat selection option is not availabe in instant booking
                  </p>
                )}
              </div>
              <div
                style={{
                  background: "#ffffff",
                  minHeight: "100%",
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "20px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                  boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                <div>
                  <div
                    style={{
                      margin: "10px",
                      padding: "12px",
                      borderRadius: "6px",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                    }}
                  >
                    <p style={{ fontSize: "16px", fontWeight: "600" }}>
                      Trip Details
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p style={{ fontSize: "16px", fontWeight: "700" }}>
                          {bus.routes[0].origin.city} to{" "}
                          {bus.routes[0].destination.city}
                        </p>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#757575",
                          }}
                        >
                          {bus.routes[0].origin.departureTime}----
                          {bus.routes[0].destination.arrivalTime}
                        </p>
                      </div>
                      <div>
                        <p style={{ fontSize: "16px", fontWeight: "700" }}>
                          {bus.busName}
                        </p>
                        <p style={{ fontSize: "16px", fontWeight: "700" }}>
                          {bus.busNumber}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      margin: "10px",
                      padding: "6px",
                      borderRadius: "6px",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "pickup"
                          ? setModalMode("")
                          : setModalMode("pickup");
                      }}
                      style={{
                        fontSize: "14px",
                        padding: "12px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {boardingPointName
                          ? boardingPointName
                          : "Select Pickup-points"}
                      </span>
                      <span>
                        {modalMode === "pickup" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "14px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "pickup" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {direction === "UP"
                          ? selectedBus.routes[0]?.additionalBoardingPoints.map(
                              (i, ind) => (
                                <div
                                  onClick={() => {
                                    setBoardingPoint(i._id);
                                    setBoardingPointName(i.name);
                                    setCurrentPickup(
                                      selectedBus.routes[0]?.fareMatrix.find(
                                        (t) => t.fromName === i.city,
                                      ),
                                    );
                                    setModalMode("");
                                    setDroppingPoint("");
                                    setDroppingPointName("");
                                  }}
                                  style={{
                                    padding: "8px",
                                    width: "70%",
                                    height: "fit-content",
                                    border: "0.3px solid gray",
                                    fontSize: "10px",
                                    backgroundColor:
                                      boardingPoint === i._id
                                        ? "rgb(2, 40, 83)"
                                        : "white",
                                    color:
                                      boardingPoint === i._id
                                        ? "rgb(255, 255, 255)"
                                        : "black",
                                    borderRadius: "10px",
                                    margin: "6px",
                                  }}
                                >
                                  <p style={{ fontWeight: "700" }}>{i.name}</p>
                                  <p style={{ fontWeight: "500" }}>
                                    {i.city} {i.pickupTime}
                                  </p>
                                </div>
                              ),
                            )
                          : selectedBus.routes[1]?.additionalBoardingPoints.map(
                              (i, ind) => (
                                <div
                                  onClick={() => {
                                    setBoardingPoint(i._id);
                                    setBoardingPointName(i.name);
                                    setCurrentPickup(
                                      selectedBus.routes[1]?.fareMatrix.find(
                                        (t) => t.fromName === i.city,
                                      ),
                                    );
                                    setModalMode("");
                                    setDroppingPoint("");
                                    setDroppingPointName("");
                                  }}
                                  style={{
                                    padding: "8px",
                                    width: "70%",
                                    height: "fit-content",
                                    border: "0.3px solid gray",
                                    fontSize: "10px",
                                    backgroundColor:
                                      boardingPoint === i._id
                                        ? "rgb(2, 40, 83)"
                                        : "white",
                                    color:
                                      boardingPoint === i._id
                                        ? "rgb(255, 255, 255)"
                                        : "black",
                                    borderRadius: "10px",
                                    margin: "6px",
                                  }}
                                >
                                  <p style={{ fontWeight: "700" }}>{i.name}</p>
                                  <p style={{ fontWeight: "500" }}>
                                    {i.city} {i.pickupTime}
                                  </p>
                                </div>
                              ),
                            )}
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      margin: "10px",
                      padding: "6px",
                      borderRadius: "6px",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "dropping"
                          ? setModalMode("")
                          : setModalMode("dropping");
                      }}
                      style={{
                        fontSize: "14px",
                        padding: "12px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {droppingPointName
                          ? droppingPointName
                          : "Select Drop-points"}
                      </span>
                      <span>
                        {modalMode === "dropping" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "15px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "dropping" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {direction === "UP" ? (
                          <div>
                            {selectedBus.routes[0]?.additionalDroppingPoints.map(
                              (i) => (
                                <div
                                  onClick={() => {
                                    setDroppingPoint(i._id);
                                    handleFareCalculation(i.name, i.city, i.id);
                                    setDroppingPointName(i.name);
                                    setModalMode("");
                                  }}
                                  style={{
                                    padding: "8px",
                                    width: "70%",
                                    height: "fit-content",
                                    border: "0.3px solid gray",
                                    fontSize: "10px",
                                    backgroundColor:
                                      droppingPoint === i._id
                                        ? "rgb(2, 40, 83)"
                                        : "white",
                                    color:
                                      droppingPoint === i._id
                                        ? "rgb(255, 255, 255)"
                                        : "black",
                                    borderRadius: "10px",
                                    margin: "6px",
                                  }}
                                >
                                  <p style={{ fontWeight: "700" }}>{i.name}</p>
                                  <p style={{ fontWeight: "500" }}>
                                    {i.city} {i.dropTime}
                                  </p>
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          <div>
                            {selectedBus.routes[1]?.additionalDroppingPoints.map(
                              (i) => (
                                <div
                                  onClick={() => {
                                    setDroppingPoint(i._id);
                                    handleFareCalculation(i.name, i.city, i.id);
                                    setDroppingPointName(i.name);
                                    setModalMode("");
                                  }}
                                  style={{
                                    padding: "8px",
                                    width: "70%",
                                    height: "fit-content",
                                    border: "0.3px solid gray",
                                    fontSize: "10px",
                                    backgroundColor:
                                      droppingPoint === i._id
                                        ? "rgb(2, 40, 83)"
                                        : "white",
                                    color:
                                      droppingPoint === i._id
                                        ? "rgb(255, 255, 255)"
                                        : "black",
                                    borderRadius: "10px",
                                    margin: "6px",
                                  }}
                                >
                                  <p style={{ fontWeight: "700" }}>{i.name}</p>
                                  <p style={{ fontWeight: "500" }}>
                                    {i.city} {i.dropTime}
                                  </p>
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    margin: "6px",
                    backgroundColor: "white",
                    boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <div style={{ display: "flex", gap: "10px" }}>
                      <p style={{ fontWeight: "700", margin: 0 }}>
                        Selected Seats
                      </p>
                      <p style={{ margin: 0 }}>x{selectedSeats.length}</p>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <p style={{ margin: 0 }}>
                        ₹
                        {selectedBus.fareDetails.basePrice *
                          selectedSeats.length}{" "}
                        /-
                      </p>
                      <p
                        style={{
                          color: "#489dbeff",
                          fontWeight: "700",
                          margin: 0,
                        }}
                      >
                        Fare Details
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <p
                      style={{
                        color: "#489dbeff",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      Total Distabce
                    </p>
                    <p style={{ margin: 0 }}>{calcDistance} Km</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "space-between",
                      padding: "10px 10px",
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <p
                      style={{
                        color: "#489dbeff",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      Total Cost
                    </p>
                    <p style={{ fontWeight: "600", fontSize: "14px" }}>
                      Onward:{upDetails?.fare}/- Return:
                      {direction === "DOWN" && calcFare}/-
                    </p>
                    <p style={{ margin: 0 }}>
                      ₹
                      {direction === "UP"
                        ? calcFare * selectedSeats.length
                        : (upDetails?.fare + calcFare) *
                          selectedSeats.length}{" "}
                      /-
                    </p>
                  </div>
                  <p
                    onClick={() => {
                      direction === "UP"
                        ? handleUpConform()
                        : handleRoundConformBooking();
                    }}
                    style={{
                      width: "100%",
                      backgroundColor: "#489dbeff",
                      padding: "3px",
                      color: "white",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                  >
                    {direction === "UP" ? "Select for Down" : "Continue"}
                  </p>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default BusDetails;
